import { api, resolvePagination } from './api';
import questionnaires from "../views/pages/QuestionnaireBuilder/questionnaireTemplates";

/**
 * Retrieve questionnaires.
 */
export const getQuestionnaires = () => api.get('/cheart/questionnaires');

/**
 * Create a new ConnectedHeart questionnaire template.
 * @param {string} name - Questionnaire name.
 * @param {string} description - Questionnaire description.
 * @param {array} questions - Questionnaire questions.
 */
export const createQuestionnaire = (name, description, questions = []) =>
    api.post('/cheart/questionnaires', {
        name,
        description,
        questions
    });

/**
 * Retrieve patient questionnaire answers.
 * @param {number} pageLimit - The maximum number of questionnaires to retrieve per page.
 * @param {string} pageToken - The token for the next page of results.
 * @param {string} query - The token for the next page of results.
 */
export const getQuestionnairesList = async (pageToken, pageLimit, query = '') => {
    const headers = resolvePagination(pageToken, pageLimit);
    const body = { query };
    return api.post('/cheart/questionnaires/search', body, { headers });
};

/**
 * Retrieve questionnaire by UUID.
 * @param {string} uuid - The UUID of the questionnaire to fetch.

export const getQuestionnaireByUUID = async (uuid) => {
    const response = await api.post('/cheart/questionnaires/fetch', { uuid });
    return response.data;
};

/**
 * Retrieve questionnaire by questions.
 * @param {string} uuid - The UUID of the questionnaire to fetch.

export const getQuestionnaireQuestions = async (uuid) => {
    const response = await api.post('/cheart/questionnaires/questions', { uuid });
    return response.data.questions;
};
**/

export const getQuestionnaireByUUID = async (uuid) => {
    const q = questionnaires.find((q) => q.uuid === uuid);
    if (!q) throw new Error('Questionário não encontrado');
    return { ...q, questions: q.data.steps };
};

export const getQuestionnaireQuestions = async (uuid) => {
    const q = questionnaires.find((q) => q.uuid === uuid);
    if (!q) throw new Error('Questionário não encontrado');
    return q.data.steps;
};

/**
 * Assign a ConnectedHeart Questionnaire to a Pacient.
 * @param {string} questionnaireUUID - The unique identifier of the questionnaire.
 * @param {string} patientUUIDs - The unique identifier of the patient.
 * @param {object} notBefore - The start date of the questionnaire notification.
 */
export const assignQuestionnaireToPatients = async (
    questionnaireUUID,
    patientUUIDs,
    notBefore = null
) => {
    const payload = {
        questionnaire: questionnaireUUID,
        patients: patientUUIDs
    };

    if (notBefore) {
        payload.not_before = notBefore;
    }

    return api.post('/cheart/questionnaire/assign/patients', payload);
};

/**
 * Assign a ConnectedHeart Questionnaire to a Group.
 * @param {string} questionnaireUUID - The unique identifier of the questionnaire.
 * @param {string} groupUUID - The unique identifier of the group.
 * @param {object} notBefore - The start date of the questionnaire notification.
 */
export const assignQuestionnaireToGroup = async (
    questionnaireUUID,
    groupUUID,
    notBefore = null
) => {
    const payload = {
        questionnaire: questionnaireUUID,
        group: groupUUID
    };

    if (notBefore) {
        payload.not_before = notBefore;
    }

    return api.post('/cheart/questionnaire/assign/group', payload);
};

/**
 * Retrieve questionnaire Answers.
 * @param {string} uuid - The UUID of the questionnaire to fetch.
 */
export const getQuestionnaireAnswerByUUID = async (uuid) => {
    const response = await api.post('/cheart/answers/fetch', { uuid });
    return response.data;
};
